var exports = {
  "y": "x112a1f60--214e78--divider",
};

module.exports = exports;
